import { FC, memo } from 'react';

import { PageSegmentLoadMetric } from '@atlassian/browser-metrics/types';

import { startMetric } from './start-metric';

export type Props = {
  metric: PageSegmentLoadMetric;
};

/**
 * A convenient component wrapper for start-metric for use with PageSegmentLoadMetric
 */
/* eslint @typescript-eslint/ban-types: "warn" */
export const PageSegmentMetricStarter: FC<Props> = memo(({ metric }) => {
  startMetric(metric);
  return null;
});
